/*
 * File: HeaderInfo.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 28 Dec 2021 1:43:26 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Row } from 'antd';
import { LabConfigurationInput } from 'components/atoms/headerInfoInputs/LabConfigurationInput';
import { SalesOrderTypeInput } from 'components/atoms/headerInfoInputs/SalesOrderTypeInput';
import { SalespersonInput } from 'components/atoms/headerInfoInputs/SalespersonInput';
import { SalesSupportInput } from 'components/atoms/headerInfoInputs/SalesSupportInput';
import { SiteInput } from 'components/atoms/headerInfoInputs/SiteInput';
import { WarehouseInput } from 'components/atoms/headerInfoInputs/WarehouseInput';
import { InventoryReservationMethodInput } from 'components/atoms/InventoryReservationMethodInput';
import { BuyerInput } from '../atoms/headerInfoInputs/BuyerInput';
import { CustomerPOInput } from '../atoms/headerInfoInputs/CustomerPOInput';
import { QuoteIdInput } from '../atoms/headerInfoInputs/QuoteIdInput';
import { ShipCompleteInput } from '../atoms/headerInfoInputs/ShipCompleteInput';

export const HeaderInfo = (): JSX.Element => {
  /* ****************** Render ****************** */
  return (
    <Row gutter={[32, 32]} style={{ width: '100%' }}>
      <Col xs={24} sm={24} md={12}>
        <CustomerPOInput />
        <QuoteIdInput />
        <BuyerInput />
        <SalespersonInput />
        <SalesSupportInput />
      </Col>
      <Col xs={24} sm={24} md={12}>
        <SalesOrderTypeInput />
        <SiteInput />
        <WarehouseInput />
        <InventoryReservationMethodInput />
        <LabConfigurationInput />
        <ShipCompleteInput />
      </Col>
    </Row>
  );
};
